module.exports = __webpack_public_path__ + "media/images/landkit/photos/photo-4-da9b0bc14a51fffe0027d2fe4fc790f0.jpg";